import { EntitlementRequestModel } from './entitlement.request.model';

export class GetEntitlementsRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetEntitlementsRequestMessage!: EntitlementRequestModel;
}
